import { plainToClass } from 'class-transformer';
import { donationHttp } from './http';
import { DonationModel } from 'models/Basket';
import { isApiError, BasketApiErrorModel } from 'models/Errors';
import { errorToBasketErrorModel } from 'helpers';

export class DonationRepository {
    public async getDonations(storeId: string = 'ONLINE'): Promise<DonationModel> {
        try {
            const url = `/api/donation/0.50/calculation/${storeId.replace(/\s+/g, '')}`;
            const response = await donationHttp.get(url);

            return plainToClass(DonationModel, response.data);
        } catch (error) {
            const errorSource = 'donation.repository:getDonations';
            if (isApiError(error)) {
                throw new BasketApiErrorModel(error, errorSource);
            } else {
                throw errorToBasketErrorModel(error, errorSource);
            }
        }
    }
}

export const donation = new DonationRepository();